import * as gxConst from "@/api/http/gx/gxConst";
import * as gxRequest from "@/api/http/gx/gxBase";
import { getUUid } from "@/api/http/utils/apiHelpers";
import {sendGXError, sendGXSuccess} from "@/utils/analytics";

/**
 *  GX 获取配置数据
 */
export const getSettingData = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const params = { next_page: await getUUid() };
      const result = await gxRequest.get(gxConst.kGetXApiPathSettings, params);
      console.log("getSettingData api result:", result);
      sendGXSuccess("getSettingData");
      resolve(result);
    } catch (error) {
      console.log("getSettingData api error:", error);
      sendGXError(error, 'getSettingData');
      reject(error);
    }
  });
};
